<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">
        {{'Add User Group' | translate}}
    </h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
        <li class="breadcrumb-item position-relative">
            {{'Users' | translate}}
        </li>
        <li class="breadcrumb-item position-relative">
            {{'Add User Group' | translate}}
        </li>
    </ol>
</div>

<mat-card class="daxa-card users-card mb-25 border-radius bg-white border-none d-block">
    <mat-card-header>
        <mat-card-title>
            {{'Add New User Group' | translate}}
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="addUserGroupForm" (ngSubmit)="onCreateUserGroup()">
            <mat-form-field>
                <mat-label>{{'Title' | translate}}</mat-label>
                <input matInput formControlName="title" />
                <mat-error *ngIf="addUserGroupForm.get('title')?.invalid">
                    {{'Title is required' | translate}}
                </mat-error>
            </mat-form-field>

            <div class="roles">
                <h5>{{'Roles' | translate}}:</h5>
                <mat-tree #tree [dataSource]="dataSource" [childrenAccessor]="childrenAccessor"
                    class="example-tree bg-white">
                    <!-- This is the tree node template for leaf nodes -->
                    <mat-nested-tree-node *matTreeNodeDef="let node">
                        <mat-checkbox (change)="
                                toggleRoleSelection(node.id, $event.checked)
                            " [checked]="selectedRoles.includes(node.id)">
                            {{ node.title }}
                        </mat-checkbox>
                    </mat-nested-tree-node>

                    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
                        [cdkTreeNodeTypeaheadLabel]="node.title">
                        <div class="mat-tree-node">
                            <button type="button" mat-icon-button matTreeNodeToggle
                                [attr.aria-label]="'Toggle ' + node.title" matTreeNodeToggle>
                                <mat-icon class="mat-icon-rtl-mirror">
                                    {{
                                    tree.isExpanded(node)
                                    ? "expand_more"
                                    : "chevron_right"
                                    }}
                                </mat-icon>
                            </button>
                            <mat-checkbox [checked]="areAllChildrenChecked(node)" [indeterminate]="
                                    areSomeChildrenRoleChecked(node) &&
                                    !areAllChildrenChecked(node)
                                " (change)="toggleAllRoles(node, $event.checked)">
                                {{ node.title }}
                            </mat-checkbox>
                        </div>
                        <div [class.example-tree-invisible]="
                                !tree.isExpanded(node)
                            " role="group">
                            <ng-container matTreeNodeOutlet></ng-container>
                        </div>
                    </mat-nested-tree-node>
                </mat-tree>
            </div>
            <div class="buttons-container">
                <button mat-raised-button class="daxa" type="submit" [disabled]="
                        addUserGroupForm.invalid ||
                        selectedRoles.length === 0 ||
                        isLoading
                    ">
                    {{ isLoading ? "Loading..." : ('Save' | translate) }}
                </button>
                <button mat-raised-button type="button" color="warn" routerLink="/users/user-groups">
                    {{ 'Cancel' | translate}}
                </button>
            </div>
        </form>
    </mat-card-content>
    <div class="alert alert-bg-danger d-flex justify-content-between align-items-center" role="alert"
        *ngIf="errorMessage">
        {{ errorMessage }}
        <button type="button" class="close bg-transparent text-white p-0 border-none" data-dismiss="alert"
            aria-label="Close" (click)="closeAlert()">
            <i class="ri-close-line"></i>
        </button>
    </div>
    <div class="alert alert-bg-success d-flex justify-content-between align-items-center" role="alert"
        *ngIf="SucessMessage">
        {{ 'User Group Added Successfully' | translate }}
        <button type="button" class="close bg-transparent text-white p-0 border-none" data-dismiss="alert"
            aria-label="Close" (click)="closeAlert()">
            <i class="ri-close-line"></i>
        </button>
    </div>
</mat-card>